import * as React from 'react';

import Tooltip from '../Tooltip';

//TODO ItemName should have the concept of how to render attunmentIcon rather than being passed a node

interface Props {
    className: string;
    onClick?: () => void;
    name: string;
    rarity: 'common' | 'uncommon' | 'rare' | 'very-rare' | 'legendary' | 'artifact';
    isCustomized: boolean;
    showIcons: boolean;
    attunementIconNode?: React.ReactNode;
    isDarkMode?: boolean;
}

export default class ItemName extends React.Component<Props> {
    static defaultProps = {
        className: '',
        isCustomized: false,
        showIcons: true,
        rarity: 'common',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { name, isCustomized, showIcons, className, rarity, attunementIconNode, isDarkMode } = this.props;

        let classNames: Array<string> = [className, 'ddbc-item-name', `ddbc-item-name--rarity-${rarity}`];
        if (isDarkMode) {
            classNames.push(`ddbc-item-name--rarity-${rarity}--dark-mode`);
        }

        return (
            <span className={classNames.join(' ')} onClick={this.handleClick}>
                {name}
                {isCustomized && (
                    <Tooltip title="Item is Customized" className="ddbc-item-name__customized" isDarkMode={isDarkMode}>
                        *
                    </Tooltip>
                )}
                {showIcons && (
                    <span className="ddbc-item-name__icon ddbc-item-name__icon--attuned">{attunementIconNode}</span>
                )}
            </span>
        );
    }
}
